import React from "react";
import { Box, Text } from "@chakra-ui/react";
import wmIcon from "../images/sensor2.png";
import { useTranslation } from "react-i18next";

export const IntercomDevice = ({ device }) => {
  const { t } = useTranslation();

    return (
       <Box mb="40px">
         <Text fontSize="sm" m="2px">
            住戶警報
         </Text>
         <Box minW="300px" borderWidth="1px" borderRadius="lg" overflow="hidden">
           <Box m="5px" display="flex" alignItems="center">
             <img width={14} height={14} src={wmIcon} />
             <Text ml="4px" fontSize="lg">
               {t("text_tenant_alarm")}
             </Text>
           </Box>
           <Box mt="10px" mb="30px" align="center">
               <Text fontSize="xl" m="10px" color="red.500">
                 {device.serialNo}
               </Text>
           </Box>
         </Box>
       </Box>
     );
};
